// extracted by mini-css-extract-plugin
export default {"button":"Auth_button__+aKeU"};